import axios from 'axios';

interface AugmentedWindow extends Window {
	__API_URL__: string;
	__WIDGET_ID__: string;
	__LOCALE__: string;
	__TOKEN__?: string;
}

const augmentedWindow = (window as unknown) as AugmentedWindow;

const {__API_URL__: apiUrl, __WIDGET_ID__: widgetId, __TOKEN__: token} = augmentedWindow;
const AUTH_TOKEN_NAME = 'Authorization';
const CHAT_TOKEN_NAME = 'X-Answers-AGS';

const safelyGetLocalStorage = () => {
	try {
		return typeof localStorage !== 'undefined' ? localStorage : null;
	} catch (e) {
		return null;
	}
};

const safelyParse = (str: string | null) => {
	try {
		return str ? JSON.parse(str) : '';
	} catch (error) {
		return '';
	}
};

const getChatHistory = async () => {
	const storage = safelyGetLocalStorage();
	const agsToken = storage ? safelyParse(storage.getItem(`_ags_${widgetId}`)) : '';
	const headers = {...(token ? {[AUTH_TOKEN_NAME]: token} : {}), ...(agsToken ? {[CHAT_TOKEN_NAME]: agsToken} : {})};

	return axios.get(`${apiUrl}/chats/my?widgetId=${widgetId}`, {headers});
};

const sendActiveChatsCount = () => {
	getChatHistory().then(({ data }) => {
		const activeChats = (data || []).filter((chat: any) => chat.chatStatus !== 2);
		parent.postMessage(
			{__ansWidget: {type: 'active-chat-count', data: {count: activeChats.length}}}, '*');
	});

};

sendActiveChatsCount();
